import { DataService } from "app/services/data.service";
import { Pipe, PipeTransform } from '@angular/core';
import { FrontEndService } from "app/services/front-end.service";

@Pipe({
  name: 'findRole'
})

export class FindRolePipe implements PipeTransform {
    constructor(
        public dataService: DataService,
        private front_end_service: FrontEndService,
    ) {}

  transform(project, chk_user = null) {

    const role = [];

    if (chk_user === null) {
        chk_user = this.dataService.currentUser;
    }

    if (project.hasOwnProperty('owner') && project.owner !== null) {
        if (project.owner.username == chk_user["username"]) {
            role.push("owner");
        }
    }

    const role_array = [
        "patent_engineer",
        "researcher",
        "reviewer",
        "technical_expert",
        "legal_counsel"
        ];

    for (const this_role of role_array) {
        if (this.dataService.get_array_details(project[this_role], "username", chk_user["username"])) {
            role.push(this_role);
        }
    }

    if (role.length === 0) {
        role.push("admin");
    }

    return role;
  }

}
